const filtrarEmailLar21ComoSistema = valor => {
  if (valor && typeof valor === 'string' && valor.includes('lar21@')) {
    return 'SISTEMA'
  }
  return valor
}

export default filtrarEmailLar21ComoSistema
